import { Component, OnInit, ViewChildren, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service'
import { ChildActivationEnd } from '@angular/router';
import { SopStep, Comments, SelectedStep } from '../Models';
import { Empty } from '@angular-devkit/core/src/virtual-fs/host';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-view-sopobserve',
  templateUrl: './ph-bhp-view-sopobserve.component.html',
  styleUrls: ['./ph-bhp-view-sopobserve.component.css']
})
export class PhBhpViewSopobserveComponent implements OnInit {
  isCollapsed = true;
  resizeFlage = true;

  @Input() formdata: any;
  @Output() action = new EventEmitter();
  @ViewChildren('card') cards;
  @ViewChild('cardHolder') cardHolder;
  @ViewChild('userCommentFrom') userCommentFrom;
  @Input() sopStep: Array<SopStep>;
  sopStepLength: number;
  @Input() seletedSteps: Array<Array<SelectedStep>> = [];
  showStepList: Object = {};
  stepCount: number = 0;
  @Input() sopName;
  @Input() sopDescription;
  @Input() comments: Array<Comments> = [];
  userComment: string;
  stepNumber: number;
  stepName: String;
  @Input() clickNoSterility: Boolean = false;
  @Input() isDesktop = true;
  @Input() observationId = 0;
  numberToName: Array<string> = [];
  stepObservations = [];
  quickCommentIndex: String;
  hovered = false;
  quickComment: Array<string> = ["Hand Disinfection Wrong", "Process Interupted", "Process"];
  showProfessionalSubcategory;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  @Input() isOverviewIndividual: boolean = false;
  swappedSteps: boolean = false;

  constructor(public service: PhBhpFeaturePackageSopobservationService, public layoutService: PHBHPLayoutPackageService, public modalRef: BsModalRef) { }

  ngOnInit() {
    if (this.sopStep) {
      this.sopStepLength = this.sopStep.length - 1;
      this.showStepList = {};
      this.sopStep.forEach((step, index) => {
        var selectedStep = this.seletedSteps[index];
        if (selectedStep) {
          this.showStepList[index] = true;
        }
      });
      this.callTimeOutLine();
    }

    // Lógica para verificar si algún paso está fuera de orden
    let visitedStepOrders: Set<number> = new Set();
    for (const step of this.seletedSteps) {
      if (step) {
        for (let i = 0; i < step.length; i++) {
          const stepCard = step[i];
          if (stepCard) {
            if (!this.previousStepsExist(visitedStepOrders, stepCard.stepOrder)) {
              stepCard.swapped = true;
              this.swappedSteps = true;
            }
            visitedStepOrders.add(stepCard.stepOrder);
          }
        }
      }
    }

    this.service.getConfigDetails(this.layoutService.institutionID).subscribe((res) => {
      if (res.enableProfessionalSubCategory) {
        this.showProfessionalSubcategory = res.enableProfessionalSubCategory;
      }
    });
  }

  showStep(index) {
    if (!this.seletedSteps[index]) {
      this.seletedSteps[index] = [];
    }
    if (!this.showStepList[index]) {
      this.showStepList[index] = true;
    }
    this.callTimeOutLine()
  }

  removeCardLine() {
    var childNodes = this.cardHolder.nativeElement.childNodes;
    childNodes.forEach((child, index) => {
      if (child.classList && child.classList.contains('horz-Line')) {
        child.remove()
      }
    })
  }

  cardNextLine() {
    var winWidth = window.innerWidth;
    let addChildNodeAtLast = false;
    this.cards.forEach((card, index) => {
      var phElement = card.nativeElement;
      if (this.cards._results[index + 1]) {
        this.cards._results[index + 1].nativeElement.classList.remove('nextRowFirstCard');
      }
      phElement.classList.remove('rowLastCard')

      var childNodes = phElement.childNodes[0];
      if (childNodes.classList && childNodes.classList.contains('rowLastCard1')) {
        childNodes.remove()
      }
      if (childNodes.classList && childNodes.classList.contains('nextRowFirstCard1')) {
        childNodes.remove()
      }

      // mutli-step-start-image
      if (this.cards._results[index + 1] && phElement.classList.contains('mutli-step-start-image')) {
        const childNodesOfMultiStack = phElement.childNodes;

        // use for each instead
        childNodesOfMultiStack.forEach(element => {
          if (element.classList && element.classList.contains('start-image-end')) {
            addChildNodeAtLast = true;
            element.remove();
          }
        });
      }

      var cardWidth = phElement.offsetWidth;
      var cardHeight = phElement.offsetHeight;
      var cardLeft = phElement.offsetLeft;
      var cardTop = phElement.offsetTop;
      var difWidth = winWidth - (cardWidth + cardLeft);
      var difHeight = cardTop + cardHeight;
      var mutliStep = false;
      if (phElement.classList.contains('mutli-step-sub-cards')) {
        mutliStep = true;
      }
      if (mutliStep) {
        var tempCardWidth = cardWidth;
      } else {
        var tempCardWidth = cardWidth + 14;
      }

      if (mutliStep) {
        var difWidth = winWidth - (cardWidth - 14 + cardLeft);
      } else {
        var difWidth = winWidth - (cardWidth + cardLeft);
      }

      if (difWidth < (tempCardWidth + 26)) {
        phElement.classList.add('rowLastCard');
        phElement.insertAdjacentHTML('afterbegin', `<div class='rowLastCard1'></div>`);
        if (this.cards._results[index + 1]) {
          var phElement1 = this.cards._results[index + 1].nativeElement;
          phElement1.classList.add('nextRowFirstCard');
          phElement1.insertAdjacentHTML('afterbegin', `<div class='nextRowFirstCard1'></div>`);
          this.cardHolder.nativeElement.insertAdjacentHTML('afterbegin', "<div class='horz-Line' style='top:" + (difHeight + 14) + "px;width:" + (cardLeft - 56) + "px'></div>");
        }
      }

      if (addChildNodeAtLast && (this.cards.length === index + 1)) {
        addChildNodeAtLast = false;
        let endImage = document.createElement('div');
        endImage.className = 'start-image-end d-flex align-items-center';

        phElement.appendChild(endImage);
      }
    });
  }

  onResize(event) {
    if (this.resizeFlage) {
      this.resizeFlage = false;
      this.removeCardLine();
      this.cardNextLine();
      this.resizeFlage = true;
    }
  }

  expanded(event) {
    this.callTimeOutLine()
  }

  callTimeOutLine() {
    setTimeout(() => {
      this.removeCardLine();
      this.cardNextLine()
    }, 1)
  }

  submitData() {
    this.action.emit({ key: 'closeViewModal' });
  }

  openComment() {
    if (this.isDesktop) {
      this.isCollapsed = !this.isCollapsed;
    } else {
      this.action.emit({
        key: 'openComment', data: {
          comments: this.comments,
          isCollapsed: this.isCollapsed,
          isEdit: false,
          observationId: this.observationId
        }
      })
    }
  }

  onchildData(value) {
    switch (value.key) {
      case 'close':
        this.isCollapsed = !this.isCollapsed;
        break;
    }
  }

  errImg(e: Event) {
    e.target['src'] = 'assets/img/fallback-img.png';
  }

  previousStepsExist(set: Set<number>, x: number): boolean {
    for (let i = 1; i < x; i++) {
      if (!set.has(i)) {
        return false;
      }
    }
    return true;
  }

}
